export const ex_data ={
    "address": "string",
    "attachments": [
      {
        "imgPath": "string"
      }
    ],
    "categoryId": 0,
    "city": "string",
    "componentsDto": {
      "additional": "string",
      "airCondition": true,
      "courtyard": true,
      "furniture": true,
      "gasStove": true,
      "internet": true,
      "tv": true
    },
    "country": "string",
    "description": "string",
    "homeAmenitiesDto": {
      "additional": "string",
      "busStop": true,
      "garden": true,
      "market": true,
      "park": true,
      "parking": true,
      "school": true,
      "stadium": true,
      "subway": true,
      "superMarket": true
    },
    "houseDetails": {
      "area": 0,
      "bath": 0,
      "beds": 0,
      "garage": 0,
      "room": 0,
      "yearBuilt": 0
    },
    "locations": {
      "latitude": 0,
      "longitude": 0
    },
    "name": "string",
    "price": 0,
    "region": "string",
    "salePrice": 0,
    "status": true,
    "zipCode": "string"
  }